import axios from "axios";
import React, { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
const AppContext = createContext();

export const useAppContext = () => {
  return useContext(AppContext);
};

export const AppProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState("tig");
  const [backendUrl, setBackendUrl] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [translations, setTranslation] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [loggedUser, setLoggedUser] = useState([]);
  const [homeContent, setHomeContent] = useState(null);
  const [isHomeLoaded, setIsHomeLoaded] = useState(false);
  const translationRoute = "/translations";

  useEffect(() => {
    const fetchHomeContent = async () => {
      if (!backendUrl) return;
      try {
        const response = await axios.get(`${backendUrl}/api/homeContent`);
        if (Array.isArray(response?.data) && response?.data?.length > 0) {
          setHomeContent(response.data[0]);
        }
      } catch (error) {
        console.error("Error fetching home content:", error);
      } finally {
        setIsHomeLoaded(true);
      }
    };
    fetchHomeContent();
  }, [backendUrl]);

  const updateFullData = (data) => {
    setFullData(data);
  };
  const updateSelectedData = (data) => {
    setSelectedData(data);
  };
  const updateSelectedTitle = (data) => {
    setSelectedTitle(data);
  };
  const decodeAndSetUser = (token) => {
    try {
      const decoded = jwtDecode(token);
      setLoggedUser(decoded);
      setIsAdmin(true); // Assuming having a token means admin status
    } catch (error) {
      console.error("Error decoding token:", error);
      setLoggedUser(null);
      setIsAdmin(false);
    }
  };

  useEffect(() => {
    setBackendUrl(process.env.REACT_APP_BACKEND_IP);

    const token = localStorage.getItem("token");
    if (token) {
      decodeAndSetUser(token);
    }

    const newLanguage = localStorage.getItem("language");
    if (newLanguage) {
      setCurrentLanguage(newLanguage);
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = currentLanguage;
  }, [currentLanguage]);
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "token") {
        if (e.newValue) {
          decodeAndSetUser(e.newValue);
        } else {
          setLoggedUser(null);
          setIsAdmin(false);
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const fetchLanguage = async () => {
      try {
        const response = await axios.get(`${backendUrl}${translationRoute}`);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setTranslation(response?.data);
        }
      } catch (error) {}
    };

    fetchLanguage();
  }, [backendUrl]);
  const changeLanguage = (language) => {
    setCurrentLanguage(language);
    localStorage.setItem("language", language);
  };

  const setAdminStatus = (status) => {
    setIsAdmin(status);
  };

  // const decodeHtmlEntities = (str) => {
  //   if (!str) return str;
  //   const txt = document.createElement("textarea");
  //   txt.innerHTML = str;
  //   return txt.value;
  // };

  // // Removes only the first and last HTML tag while keeping inner tags
  // const stripOuterHtml = (html) => {
  //   if (!html) return html;

  //   return html.replace(/^<[^>]+>(.*)<[^>]+>$/s, "$1").trim();
  // };

  // const normalize = (text) => {
  //   return text
  //     .replace(/[\r\n]+/g, " ")
  //     .replace(/[^\w\s]/g, "")
  //     .toUpperCase();
  // };

  // const capitalize = (text) => {
  //   if (!text) return text;
  //   return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  // };

  // const translate = (htmlString) => {
  //   if (!htmlString) return htmlString;

  //   // Decode HTML Entities
  //   const decodedHtmlString = decodeHtmlEntities(htmlString);

  //   // Remove only the outermost tags
  //   const cleanedHtml = stripOuterHtml(decodedHtmlString);
  //   const normalizedWord = normalize(cleanedHtml);

  //   const translation = translations.find((t) => {
  //     const decodedStoredWord = decodeHtmlEntities(t.word);
  //     const normalizedStoredWord = normalize(stripOuterHtml(decodedStoredWord));
  //     return normalizedStoredWord === normalizedWord;
  //   });

  //   if (translation && translation.translation[currentLanguage]) {
  //     const translatedText = decodeHtmlEntities(
  //       translation.translation[currentLanguage]
  //     );
  //     return translatedText ? capitalize(translatedText) : cleanedHtml;
  //   }

  //   return cleanedHtml; // Return text without the outermost tags
  // };

  /////////////////better for bold
  // const decodeHtmlEntities = (str) => {
  //   const txt = document.createElement("textarea");
  //   txt.innerHTML = str;
  //   return txt.value;
  // };

  // const normalizeText = (str) => {
  //   // Remove HTML tags and trim, lowercase for safe matching
  //   return str
  //     .replace(/<[^>]*>/g, "")
  //     .trim()
  //     .toLowerCase();
  // };

  // const translate = (htmlString) => {
  //   if (!htmlString || typeof htmlString !== "string") return htmlString;

  //   const decodedInput = decodeHtmlEntities(htmlString);
  //   const normalizedInput = normalizeText(decodedInput);

  //   const match = translations.find((t) => {
  //     const storedWord = decodeHtmlEntities(t.word);
  //     const normalizedStored = normalizeText(storedWord);
  //     return normalizedStored === normalizedInput;
  //   });

  //   if (match && match.translation[currentLanguage]) {
  //     return decodeHtmlEntities(match.translation[currentLanguage]);
  //   }

  //   // Fallback: return original (decoded) HTML
  //   return decodedInput;
  // };
  const decodeHtmlEntities = (str) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  };

  // const normalizeText = (str) => {
  //   return str
  //     .replace(/<[^>]*>/g, "") // Remove HTML tags
  //     .replace(/\s+/g, " ") // Normalize all spaces, tabs, newlines to a single space
  //     .trim()
  //     .toLowerCase(); // Lowercase for safe matching
  // };
  const normalizeText = (str) => {
    return decodeHtmlEntities(str)
      .replace(/<span class="ql-cursor">.*?<\/span>/g, "") // Remove Quill cursor artifacts
      .replace(/<br\s*\/?>/gi, " ") // Replace <br> tags with space
      .replace(/<\/p>\s*<p>/gi, " ") // Replace paragraph breaks with space
      .replace(/<[^>]+>/g, "") // Strip all remaining HTML tags
      .replace(/\s+/g, " ") // Normalize whitespace
      .trim()
      .toLowerCase();
  };
  const translate = (htmlString) => {
    if (!htmlString || typeof htmlString !== "string") return htmlString;

    const decodedInput = decodeHtmlEntities(htmlString);
    const normalizedInput = normalizeText(decodedInput);

    const match = translations.find((t) => {
      const storedWord = decodeHtmlEntities(t.word);
      const normalizedStored = normalizeText(storedWord);
      return normalizedStored === normalizedInput;
    });

    if (match && match.translation[currentLanguage]) {
      return decodeHtmlEntities(match.translation[currentLanguage]);
    }

    // Fallback: return original (decoded) HTML
    return decodedInput;
  };

  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return (
    <AppContext.Provider
      value={{
        backendUrl,
        isAdmin,
        setAdminStatus,
        changeLanguage,
        currentLanguage,
        translations,
        translate,
        selectedData,
        updateSelectedData,
        fullData,
        updateFullData,
        loggedUser,
        decodeAndSetUser,
        selectedTitle,
        updateSelectedTitle,
        homeContent,
        isHomeLoaded,
        getImageUrl: (path) => {
          if (!path) return "";
          const formattedPath = path.replace(/\\/g, "/");
          return `${backendUrl}/${formattedPath}`;
        },
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
